import { StageDefinition } from './StageDefinition';

export const stage03: StageDefinition = {
    platforms: [
        [267.09677419354847, 0],
        [278.70967741935493, 0],
        [290.3225806451614, 0],
        [301.93548387096786, 0],
        [37.89473684210526, 1],
        [47.368421052631575, 1],
        [56.84210526315789, 1],
        [198.94736842105254, 1],
        [208.42105263157885, 1],
        [217.89473684210515, 1],
        [90.00000000000001, 2],
        [98.1818181818182, 2],
        [106.36363636363639, 2],
        [114.54545454545458, 2],
        [122.72727272727276, 2],
        [130.90909090909093, 2],
        [139.09090909090912, 2],
        [147.2727272727273, 2],
        [220.909090909091, 2],
    ],
    traps: [],
    stars: [
        [102, 4],
        [126, 4],
        [224, 4],
    ],
};
